import { Component, OnInit, Inject, ViewChild } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import { GooglePlaceDirective } from "ngx-google-places-autocomplete";
import { Address } from "ngx-google-places-autocomplete/objects/address";
import * as _ from "lodash";
import { DeliveryZoneService } from "./delivery-zone-service/delivery-zone.service";
import { SpinnerService } from "src/app/shared/services/spinner.service";
import { Dbutils } from "src/app/shared/services/db-utils";

@Component({
  selector: "app-delivery",
  templateUrl: "./delivery.component.html",
  styleUrls: ["./delivery.component.scss"],
})
export class DeliveryComponent implements OnInit {
  @ViewChild("placesRef") placesRef: GooglePlaceDirective;
  options = {
    types: [],
    componentRestrictions: { country: "IL" },
  };
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dbUtils: Dbutils,
    private dialogRef: MatDialogRef<DeliveryComponent>,
    private spinnerService: SpinnerService,
    private zoneService: DeliveryZoneService
  ) {}
  private now: boolean = true;
  houres: string[] = [
    "13:00",
    "13:30",
    "14:00",
    "14:30",
    "15:00",
    "15:30",
    "16:00",
    "16:30",
    "17:00",
    "17:30",
    "18:00",
    "18:30",
    "19:00",
    "19:30",
    "20:00",
    "20:30",
    "21:00",
    "21:30",
    "22:00",
  ];
  error: string;
  selectedStreet: string;
  selectedCity: string;
  selectedHouseNumber: number;
  selectedFloor: number;
  branch: string;
  customerLocation;
  ngOnInit() {}

  choosenNow(event) {
    this.now = event;
  }

  public handleAddressChange(address: Address) {
    _.map(address.address_components, (address) => {
      if (address.types[0] === "street_number") {
        this.selectedHouseNumber = address.long_name;
      }

      if (address.types[0] === "route") {
        this.selectedStreet = address.long_name;
      }

      if (address.types[0] === "locality") {
        this.selectedCity = address.long_name;
      }
    });
    this.customerLocation = [
      address.geometry.location.lng(),
      address.geometry.location.lat(),
    ];
    console.log("customerLocation" ,  this.customerLocation)
  }

  public async submit() {
    this.error = null;
    this.spinnerService.show();
    if (this.checkValidateAddress()) {
      const branch = await this.checkIfAddressInZone();
      this.spinnerService.hide();
      if (_.isEmpty(branch) || _.isNil(branch)) {
        this.error = "לא קיים סניף אשר עושה שליחויות לכתובת זו";
        return;
      }
      this.branch = branch;
      this.dialogRef.close({
        branch: this.branch,
        city: this.selectedCity,
        street: this.selectedStreet,
        houseNumber: this.selectedHouseNumber,
        floor: this.selectedFloor,
      });
    }
    this.spinnerService.hide();
  }

  public checkValidateAddress(): boolean {
    if (_.isEmpty(this.selectedCity)) {
      this.error = "עיר לא תקינה";
      return false;
    }
    if (_.isEmpty(this.selectedStreet)) {
      this.error = "כתובת לא תקינה";
      return false;
    }
    if (_.isNil(this.selectedHouseNumber)) {
      this.error = "חסר מספר בית";
      return false;
    }
    if (_.isNil(this.selectedFloor)) {
      this.error = "חסר קומה";
      return false;
    }
    if (_.isNil(this.error)) {
      return true;
    }
  }

  async checkIfAddressInZone() {
    let res = "";
    const branches = await this.dbUtils.getBranches();
    const array = _.values(branches);
    for (let index = 0; index < array.length; index++) {
      const branch = array[index];
      let polygon = branch.coordinates;
      if (!_.isNil(polygon)){
        console.log( "polygon", this.customerLocation +" "+  branch.branchName+" "+ 
          polygon)
        const branchIsExist = this.zoneService.inside(
          this.customerLocation,
          polygon
        );
        if (branchIsExist) {
          res = branch;
        }
      }  
    }
    return res;
  }

  changeToTa() {
    this.dialogRef.close({ ta: true });
  }
}
